import { workStatusSummary } from '@/features/chat/phase1/workStatusThoughts'
import { taskRuns } from '@/features/chat/phase1/taskRuns'

/**
 * Attach a live snapshot to the assistant message whose run is doing the work.
 *
 * Every run that touched a task counts, not just the one that created it: a
 * turn that only resumes earlier tasks creates none of its own, so matching on
 * `origin_run_id` attached its snapshot to the *previous* message and left the
 * in-flight one blank.
 */
export function applyLiveWorkStatus(prev, threadId, workStatus) {
  const origins = new Set((workStatus?.tasks ?? []).flatMap(taskRuns))
  if (!origins.size) return prev
  const list = prev[threadId] ?? []
  let index = -1
  for (let cursor = list.length - 1; cursor >= 0; cursor -= 1) {
    const message = list[cursor]
    if (message.role === 'assistant' && origins.has(message.phase1RunId)) {
      index = cursor
      break
    }
  }
  if (index === -1) return prev
  const currentRevision = list[index].workStatus?.revision ?? -1
  if (typeof workStatus.revision === 'number' && workStatus.revision <= currentRevision) return prev
  const next = list.slice()
  next[index] = {
    ...next[index], workStatus,
    thoughtSummary: workStatusSummary(workStatus) ?? next[index].thoughtSummary,
  }
  return { ...prev, [threadId]: next }
}
